export default () => {
  window.openModal = (source) => {
    window.openModalByQuery(`#${source.dataset.modalid}`);
  };

  window.openModalByQuery = (query) => {
    const modal = document.querySelector(query);
    const html = document.querySelector('html');
    modal.classList.add('is-active');
    html.classList.add('is-clipped');

    modal.querySelector('.modal-background').addEventListener('click', (e) => {
      e.preventDefault();
      window.closeModal(modal);
    });
    modal.querySelector('.modal-close').addEventListener('click', (e) => {
      e.preventDefault();
      window.closeModal(modal);
    });
  };

  window.closeModal = (modal) => {
    const html = document.querySelector('html');
    modal.classList.remove('is-active');
    html.classList.remove('is-clipped');
  };

  window.closeModalByQuery = (query) => {
    const modal = document.querySelector(query);
    window.closeModal(modal);
  };

  window.addEventListener('phx:closeModal', (e) => {
    console.debug('closing the modal via phx:closeModal', e);
    window.closeModalByQuery(e.detail.id);
  });

  window.addEventListener('phx:openModal', (e) => {
    console.debug('opening the modal via phx:openModal', e);
    window.openModalByQuery(e.detail.id);
  });
};
